import styled from 'styled-components';

import { Breakpoint, Color, DialogTheme, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Button } from '../button/button.component';
import { Markdown } from '../markdown/markdown.component';

import { ContainerProps, OverlayProps } from './smallDialog.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${ZIndex.SmallDialog};
  background-color: ${Color.White};
  width: ${({ $theme }: ContainerProps): string => $theme === DialogTheme.Big
    ? '880px'
    : $theme === DialogTheme.Medium
      ? '600px'
      : '460px'};
  max-width: 100%;
  transition: 0.3s;
  overflow-y: auto;
  max-height: 95%;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ $isVisible }: ContainerProps): string => $isVisible ? `
    opacity: 1;
  ` : `
    opacity: 0;
    pointer-events: none;
  `};

  @media ${Breakpoint.Mobile} {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const ContentSection: StyledComponent<'div'> = styled.div`
  padding: 24px 24px 56px;
  position: relative;
`;

export const Header: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 18px;
  line-height: 26px;
  color: ${Color.Black};
  border-bottom: 1px solid ${Color.Gray300};
  padding-bottom: 24px;
  padding-right: 34px;
  margin-bottom: 24px;
`;

export const Content: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
`;

export const CloseButton: StyledComponent<'button'> = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background-color: ${Color.Gray200};
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonsSection: StyledComponent<'div'> = styled.div`
  background-color: ${Color.Gray200};
  padding: 24px;
  display: flex;
  align-items: center;

  @media ${Breakpoint.SmallMobile} {
    flex-direction: column;
  }
`;

export const Overlay: StyledComponent<'div', OverlayProps> = styled.div<OverlayProps>`
  background-color: ${hexToRgba(Color.Black, 0.25)};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${ZIndex.Zero};
  transition: 0.3s;
  ${({ $isVisible }: OverlayProps): string => $isVisible ? `
    opacity: 1;
  ` : `
    opacity: 0;
    pointer-events: none;
  `};
`;

export const StyledButton: StyledComponent<typeof Button> = styled(Button)`
  & + & {
    margin-left: 10px;

    @media ${Breakpoint.SmallMobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }
`;

export const SmallDialogWrapper: StyledComponent<'div'> = styled.div``;
